import { jsx as a } from "@emotion/react/jsx-runtime";
import { AvatarMenuItemContainer as n } from "./AvatarMenuItem.styled.js";
const m = ({
  children: t,
  callback: r,
  dataTrackId: e
}) => /* @__PURE__ */ a(n, { "data-track": e, onClick: r, gap: "8px", direction: "row", alignItems: "center", children: t });
export {
  m as AvatarMenuItem
};
